import React, { useState } from "react";
import ReactDOM from "react-dom";
import { AiFillStar } from "react-icons/ai";
import { useSelector } from "react-redux";
import { addRating } from "../actions/articleActions";

const Rating = ({ name, open, children, setShowModal }) => {
  const [checkedValue, setCheckedValue] = useState(0);
  const user = useSelector((state) => state.session);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e) => {
    let checked = e.target.checked;
    if (checked) {
      setCheckedValue(e.target.value);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (user) {
      const data = {
        rating: checkedValue,
      };

      await addRating(data, name);
      setSubmitted(true);
    } else {
      console.log("login first");
    }
  };
  if (!open) return null;
  return ReactDOM.createPortal(
    <div className="portal">
      {children}
      <div className="container">
        {!submitted ? (
          <form className="star-widget" onSubmit={handleSubmit}>
            <input
              type="radio"
              name="rate"
              id="rate-5"
              value="5"
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="rate-5">
              <AiFillStar />
            </label>

            <input
              type="radio"
              name="rate"
              id="rate-4"
              value="4"
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="rate-4">
              <AiFillStar />
            </label>

            <input
              type="radio"
              name="rate"
              id="rate-3"
              value="3"
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="rate-3">
              <AiFillStar />
            </label>

            <input
              type="radio"
              name="rate"
              id="rate-2"
              value="2"
              onChange={(e) => handleChange(e)}
            />
            <label htmlFor="rate-2">
              <AiFillStar />
            </label>

            <input
              type="radio"
              name="rate"
              value="1"
              onChange={(e) => handleChange(e)}
              id="rate-1"
            />
            <label htmlFor="rate-1">
              <AiFillStar />
            </label>
            <div className="text-rate"></div>
            <div className="feedback-buttons">
              <button onClick={() => setShowModal(false)}>No Later</button>
              <button type="submit">Submit Feedback</button>
            </div>
          </form>
        ) : (
          <form className="star-widget">
            <h2 style={{ color: "yellow", marginBottom: "50px" }}>
              Thanks for the Rating
            </h2>
            <div className="feedback-buttons">
              <button onClick={() => setShowModal(false)}>
                You're welcome
              </button>
            </div>
          </form>
        )}
      </div>
    </div>,
    document.getElementById("portal")
  );
};

export default Rating;
